import dynamic from 'next/dynamic';
import React, { useRef } from 'react';
import config from 'Config';
import { GOOGLE_API_KEY } from 'Components/utils/google/google.constants';
const GoogleMapReact = dynamic(() => import('google-map-react'), {
  ssr: false,
});
type StreetViewProps = {
  fov?: number;
  heading?: number;
  hideFloorControls?: boolean;
  latitude: number;
  longitude: number;
};

const addStreetView = ({ hideFloorControls, map, maps, position, pov, ref }) => {
  const panorama = new maps.StreetViewPanorama(ref, {
    addressControl: true,
    addressControlOptions: {
      position: maps.ControlPosition.TOP_LEFT,
    },
    disableDefaultUI: hideFloorControls,
    fullscreenControl: false,
    position,
    pov,
    linksControl: true,
    panControl: true,
    zoomControl: true,
  });
  map.setStreetView(panorama);
};

export function StreetView(props: StreetViewProps) {
  const { fov = 2, heading = 2, hideFloorControls = false, latitude, longitude } = props;

  const _map: {
    current: HTMLDivElement | null | undefined;
  } = useRef();

  const coordinates = {
    lat: latitude,
    lng: longitude,
  };
  return (
    <div className="h-full" data-testid="StreetViewComponent" ref={_map}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: config.get(GOOGLE_API_KEY),
        }}
        defaultCenter={coordinates}
        defaultZoom={fov}
        onGoogleApiLoaded={({ map, maps }) =>
          addStreetView({
            hideFloorControls,
            map,
            maps,
            position: coordinates,
            pov: {
              heading,
              pitch: 0,
            },
            // same here, for now
            ref: _map.current,
          })
        }
        yesIWantToUseGoogleMapApiInternals
      />
    </div>
  );
}
